// Page questionnaire sportives (mobile-first). À brancher sur une route
// (ex. /questionnaire/sportive).
import React from 'react';
import SurveyWizard from './SurveyWizard';

export default function SurveyAthletePage() {
  // Accent rose (thème Mental de CycleGala).
  return <SurveyWizard form="athlete" accent="#F93E6E" />;
}
